// extracted by mini-css-extract-plugin
export default {"history":"History_history__lbEkS","kindBadge":"History_kindBadge__rNg3n","kindIcon":"History_kindIcon__c0RY7","info":"History_info__h0jg9"};